/**
 * Generates a unique id for use in avoiding id collisions.
 * Definitely not safe for cryptography.
 * @param prefix
 */
export function uniqueId(prefix = '') {
  return prefix + Math.floor(Math.random() * 9e15).toString(18);
}
